import { makeVar } from "@apollo/client";

/**
 * Interface defining the structure of the reactive variable for form state.
 */
export interface FormState {
    type: string | null; // Type of the form (e.g., "net_pension", "withholding_tables").
    data: any | null; // Data associated with the form (e.g., field configurations).
    tooltipShow: boolean; // Whether tooltips are displayed or not.
    submitted: boolean | object | null; // Indicates if the form was submitted.
    currentValues: Record<string, any> | null; // Current values of form fields.
}

/**
 * Reactive variable to manage form state using Apollo Client's `makeVar`.
 */
const form = makeVar<FormState>({
    type: null,
    data: null,
    tooltipShow: false,
    submitted: null,
    currentValues: null,
});


export default form;
